<template>
	<div>
	   <div class="waga" v-show="show">
		<div class="title"> {{ title }} </div><br/><br/>
		<div class="stitlegreen"> 
		<p>{{akcja}} zostało wykonane poprawnie. <br/> Możesz teraz wykonać kolejną operację.</p> 
		</div>
	    </div>
	    <div class="podwaga">
		<div class="wleft">
        		<button class="wlabel"> WRÓĆ </button>
     		</div>
	    </div>
		<div class="wcenter">
			<button class="wlabel" @click="drukujetykiete" v-show="showprint"> DRUKUJ ETYKIETĘ </button>
		</div>
		<div class="wcenter">
			<button class="wlabel" @click="przejdzdoprzyjecia" v-show="showmove"> PRZEJDŹ DO PRZYJĘCIA WYROBU GOTOWEGO </button>
		</div>
		<div class="wright">
			<button class="wlabel commit" @click="wrocdomenu"> WRÓĆ DO MENU </button>
		</div>
	</div>
</template>

<script>

import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
import Vue from "vue";
import Storage from "./Storage";
import * as CONFIG from "./config.js";

export default {
  name: "waga",
  components: { 
  },
  props: {
    nazwa: String,
    wroc: String,
  },
  data: () => ({
	title: "",
	subtitle: "",
	akcja: "",
	show: true,
	showprint: false,
	showmove: false,
	whereto: "",
	backto: "",
	id_uzytkownika: -1,
	id_dok: 0,
	iloscnosnika: 0,
	noswaga: 0,
	ilopak: 0,
	sumaopak: 0,
	nadwyzka: 0,
	id_nosnika: 0,
	id_opakowania: 0,
	typ_zlecenia: "",
	id_zlecenia: 0,
  }),
  methods: {
	wrocclick() {
		if(this.typ_zlecenia !== "")
			this.$router.push({ path: this.backto + this.whereto + "&typ_zlecenia=" + this.typ_zlecenia});
		else 
			this.$router.push({ path: this.backto + this.whereto });

	},
	wrocdomenu(){
		this.$router.push({ path: 'main' });
	},
	drukujetykiete(){
		this.$router.push({ path: "/pweetykieta", query: { item: this.id_dok, skrzynia: 0, id_zlecenia: this.id_zlecenia,  iloscnosnika: this.iloscnosnika, noswaga: this.noswaga, ilopak: this.ilopak, sumaopak: this.sumaopak, nadwyzka: this.nadwyzka, id_nosnika: this.id_nosnika, id_opakowania: this.id_opakowania ,prev: this.backto + this.whereto }});
	},
	przejdzdoprzyjecia(){
		console.log('id zlecenia: ' + this.id_zlecenia)
		this.$router.push({ path: "/dokumentpzprzyjecie" + "?id_zlecenia=" + this.id_zlecenia });
	}
  },
  mounted() {
	var params = this.$route.query;
        var prev = "";
        var prev3 = "";
	var id_dok_mag = "";
	var id_zlecenia = "";
	var id_odpadu = "";
	var id_skrzyni = "";
	var skrzyn = "";
	
        if (params["prev2"]) {
             prev = params["prev2"];
	     this.whereto="?prev=" + prev;
	}
	if(params["iddokmag"]){
		this.id_dok = params["iddokmag"]
		this.showprint = true
	}
	if (params["mag"]) {
	     id_dok_mag = params["mag"];
	     this.whereto += "&mag=" + id_dok_mag;
	}
	if (params["id_zlecenia"]) {
	     id_zlecenia = params["id_zlecenia"];
	     this.whereto += "&id_zlecenia=" + id_zlecenia;
		 this.id_zlecenia =  params["id_zlecenia"];
		 console.log('przyjecie zlecenie id: ' + this.id_zlecenia)
	}
	if (params["id_odpadu"]) {
	     id_odpadu = params["id_odpadu"];
	     this.whereto += "&id_odpadu=" + id_odpadu;
	}
        if (params["id_skrzyni"]) {
             id_skrzyni = params["id_skrzyni"];
             this.whereto += "&id_skrzyni=" + id_skrzyni;
        }
        if (params["skrzyn"]) {
             skrzyn = params["skrzyn"];
             this.whereto += "&skrzyn=" + skrzyn;
        }
        if (params["prev3"]) {
             prev3 = params["prev3"];
             this.whereto += "&prev2=" + prev3;
        }
	if (params["prev2"]) {
		var pp = params["prev2"];
		if (pp.indexOf("odpady") != -1) {
			this.title = "ODSORTY > ZLECENIA > ODSORTY > LISTA DOKUMENTÓW PZ > Opakowanie > Waga > Potwierdzenie";
			this.backto = "/zleceniaodpady";
			this.akcja = "Przyjęcie"
		} else if (pp.indexOf("dokumentpzprzyjecie") != -1) {
			this.title = " PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ > Nośnik i Opakowanie > Waga > Potwierdzenie";
			this.backto = "/nosnikopakowanie";
			this.whereto = "?prev=dokumentpzprzyjecie&id_zlecenia=" + id_zlecenia + "&mag=" + id_dok_mag + "&prev2=zleceniaartykul";
			this.akcja = "Przyjęcie"
			if(params["iloscnosnika"]){
				console.log(this.iloscnosnika)
				this.iloscnosnika = params["iloscnosnika"]
			}
			if(params["noswaga"]){
				this.noswaga = params["noswaga"]
			}
			if (params["ilopak"]){
				this.ilopak = params["ilopak"]
			}
			if (params["sumaopak"]){
				this.sumaopak = params["sumaopak"]
			}
			if (params["nadwyzka"]){
				this.nadwyzka = params["nadwyzka"]
			}
			if (params["id_nosnika"]){
				this.id_nosnika = params["id_nosnika"]
			}
			if (params["id_opakowania"]){
				this.id_opakowania = params["id_opakowania"]
			}

			
			this.$router.push({ path: "/pweetykieta", query: { item: this.id_dok, skrzynia: 0, id_zlecenia: this.id_zlecenia,  iloscnosnika: this.iloscnosnika, noswaga: this.noswaga, ilopak: this.ilopak, sumaopak: this.sumaopak, nadwyzka: this.nadwyzka, id_nosnika: this.id_nosnika, id_opakowania: this.id_opakowania ,prev: this.backto + this.whereto  }});
		} else {
			this.title = "WYDANIE Z MAGAZYNU > ZLECENIA > LISTA DOKUMENTÓW PZ > Opakowanie > Waga > Potwierdzenie";
			this.backto = "/dokumentpzwydanie";
			this.whereto = "?prev=zleceniawydanie&id_zlecenia=" + id_zlecenia;
			this.akcja = "Wydanie"
			if (params["typ_zlecenia"]) {
                this.typ_zlecenia = params["typ_zlecenia"];
				this.showmove = true
				console.log('typ zlecenia ' + this.typ_zlecenia)
        	}


		}
	}

	let that = this;
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	//document.querySelector(".wright").addEventListener('click', function() { that.commitclick(); } );

    },
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }

    .e-numeric .e-input-group-icon.e-spin-down {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }
    /* csslint ignore:end */

.waga {
	margin-bottom:5%;
}
.podwaga {
	clear:both;
	margin-top: 30px;
}
.commit {
	width: 200px;
	height: 50px;
}

.nazwa {
}


.stitlegreen {
	height: 500px;
	color:green;
	font-size: 2em;
	font-weight: bold;
}
p{
	padding-top: 150px;
}
.wrap {
margin: 5% auto;
width: 240px;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>




// WEBPACK FOOTER //
// src/components/PotwierdzenieOK.vue